export default class Keys {
  static JWT_TOKEN = 'FrontierJwtToken';
}
